import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoins = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 4.0625C3 4.0625 0 4.96875 0 6.75V13.25C0 15.0625 3 16 6 16C8.96875 16 12 15.0625 12 13.25V6.75C12 4.96875 9 4.0625 6 4.0625ZM10.5 13.25C10.5 13.5938 8.9375 14.5 6 14.5C3.03125 14.5 1.5 13.5938 1.5 13.25V11.9062C2.625 12.4688 4.3125 12.75 6 12.75C7.65625 12.75 9.34375 12.4688 10.5 11.9062V13.25ZM10.5 10C10.5 10.3438 8.9375 11.25 6 11.25C3.03125 11.25 1.5 10.3438 1.5 10V8.65625C2.625 9.21875 4.3125 9.5 6 9.5C7.65625 9.5 9.34375 9.21875 10.5 8.65625V10ZM6 8C3.03125 8 1.5 7.09375 1.5 6.75C1.5 6.4375 3.03125 5.5 6 5.5C8.9375 5.5 10.5 6.4375 10.5 6.75C10.5 7.09375 8.9375 8 6 8ZM10 0C6.40625 0 4.21875 1.25 4.21875 2.15625C4.21875 2.46875 4.46875 2.90625 4.96875 2.90625C5.6875 2.90625 5.90625 1.5 10 1.5C12.9375 1.5 14.5 2.4375 14.5 2.75C14.5 2.8125 14.2812 3.1875 13.25 3.53125C12.9375 3.65625 12.7188 3.9375 12.7188 4.25C12.7188 4.65625 13.0625 5 13.5 5C13.75 5 14.3438 4.71875 14.5 4.65625V6C14.5 6.0625 14.25 6.46875 13.2188 6.8125C12.9062 6.90625 12.7188 7.1875 12.7188 7.53125C12.7188 7.9375 13.0312 8.28125 13.4688 8.28125C13.75 8.28125 14.375 7.9375 14.5 7.90625V9.25C14.5 9.3125 14.2812 9.6875 13.25 10.0312C12.9375 10.1562 12.7188 10.4375 12.7188 10.75C12.7188 11.1562 13.0625 11.5 13.5 11.5C13.6875 11.5 16 10.8438 16 9.25V2.75C16 0.96875 12.9688 0 10 0Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgCoins);
export { ForwardRef as ReactComponent };
